export const contacts = {
  title: "Наши контакты",
  organization:
    "Южно-Российский институт управления – филиал федерального государственного бюджетного образовательного учреждения высшего образования «Российская академия народного хозяйства и государственной службы при Президенте Российской Федерации»",
  department: "Научно-организационный отдел",
  contactPerson: "Войнова Анастасия Александровна",
  email: "voynova-aa@ranepa.ru",
  phone: "8 (863) 270-07-44",
  room: "812",
  address: "г. Ростов-на-Дону, ул. Пушкинская, д. 70/54",
};
